import { FieldTypeDisplay } from 'module/api/field/types';
import { unreachable } from 'module/helpers/unreachable';
import { FieldType } from 'module/types/filter-field/field/field';
import { FilterableField } from 'module/types/filter-field/field/filterable-field';
import { FieldFilter } from 'module/types/filter-field/filter';
import { BooleanFilterOperationType } from 'module/types/filter-field/filter/boolean';
import { DateFieldFilterOperationType } from 'module/types/filter-field/filter/date';
import {
  EstimateFieldFilterOperationType,
  EstimateRelativeDirection,
} from 'module/types/filter-field/filter/estimate';
import { NumberFilterOperationType } from 'module/types/filter-field/filter/number';
import { SelectFilterOperationType } from 'module/types/filter-field/filter/select';
import { TextFieldFilterOperationType } from 'module/types/filter-field/filter/text';

export const getDefaultCriteria = (field: FilterableField): FieldFilter => {
  switch (field.type) {
    case FieldType.Boolean:
      return { field, type: BooleanFilterOperationType.IsTrue };
    case FieldType.Estimate:
      return {
        field,
        type: EstimateFieldFilterOperationType.IsMoreThan,
        direction: EstimateRelativeDirection.Early,
        days: 0,
      };
    case FieldType.Number:
      return { field, type: NumberFilterOperationType.IsGreaterThan };
    case FieldType.Text:
    case FieldType.MultiLineText:
      return { field, type: TextFieldFilterOperationType.Contains };
    case FieldType.Date:
      // This is a dirty hack just for automations matching conditions, if u r angry I cant help
      if (field?.metaData?.showAllOps === true) {
        return {
          field,
          type: DateFieldFilterOperationType.IsEmpty,
        };
      }

      return {
        field,
        type: DateFieldFilterOperationType.IsToday,
      };
    case FieldType.SingleSelect:
      if (field.fieldName === 'taskDependencyStatus') {
        return {
          field,
          type: SelectFilterOperationType.IsOneOf,
          value: undefined,
        };
      }

      if (field.fieldName === 'sprint') {
        return {
          field,
          type: SelectFilterOperationType.IsNotEmpty,
        };
      }

      if (field.fieldTypeDisplay === FieldTypeDisplay.Level) {
        return {
          field,
          type: SelectFilterOperationType.IsAtLeast,
          value: undefined,
        };
      }

      return {
        field,
        type: SelectFilterOperationType.Is,
        value: undefined,
      };
    case FieldType.MultiSelect:
      if (field.fieldName === 'associatedSprints') {
        return {
          field,
          type: SelectFilterOperationType.IsNotEmpty,
        };
      }

      return { field, type: SelectFilterOperationType.Is, value: [] };
    case FieldType.SingleUser:
      return { field, type: SelectFilterOperationType.IsOneOf, value: [] };
    case FieldType.MultiUser:
      return { field, type: SelectFilterOperationType.Is, value: [] };
    case FieldType.Assignee:
      return { field, type: SelectFilterOperationType.IsOneOf, value: [] };
    case FieldType.Note:
      return {
        field,
        type: TextFieldFilterOperationType.Contains,
      };
    default:
      return unreachable(field);
  }
};
